import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
// const baseUrl = process.env.REACT_APP_API_BASE_URL;
import logo from '../../assets/gg-logo.png'
import diamondicon from '../../assets/diamond-icon.png'
import { Gamepad2, History } from "lucide-react";


const Navbar = ({ abc, xyz }) => {
  const [coinValue, setCoinValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  // Fetch coin value from API
  useEffect(() => {
    const fetchCoinValue = async () => {
      if (!abc || !xyz) {
        return;
      }

      try {
        setLoading(true);

        const response = await fetch("https://api.gamegems.co/web/games/verify", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ abc, xyz }),
        });

        if (!response.ok) throw new Error("Verification failed");

        const data = await response.json();

        if (data.status && data.message === "success") {
          setCoinValue(data.data?.coin || 0);
        }
      } catch (err) {
        console.error("Failed to fetch coin value:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCoinValue();
  }, [abc, xyz]);

  const createUrl = (path) => {
    const params = new URLSearchParams();
    if (abc) params.set('abc', abc);
    if (xyz) params.set('xyz', xyz);
    return `${path}?${params.toString()}`;
  };

  const isActive = (path) => location.pathname === path;

  // const navigate = useNavigate();

  // const handleLogout = async () => {

  //   try {
  //     const token = localStorage.getItem("token");

  //     if (!token) {
  //       throw new Error("No token found");
  //     }

  //     const response = await fetch(`${baseUrl}/auth/logout`, {
  //       method: "GET",
  //       headers: {
  //       "Authorization": `Bearer ${token}`
  //     }
  //     });

  //     const result = await response.json();

  //     if (result?.status === true) {
  //       alert("Logged out successfully");
  //       localStorage.removeItem("token");
  //       navigate("/");
  //     } else {
  //       console.error("Logout failed:", result.message);
  //     }
  //   } catch (err) {
  //     console.error("Logout Error:", err.message);
  //   }

  // };

  const navLinkClass = (path) =>
    `flex items-center gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition whitespace-nowrap ${
      isActive(path) ? "bg-black text-white" : "text-white/90 hover:bg-white/10"
    }`;

  return (
    <div className="bg-black shadow-lg py-2 px-2 sm:px-4 flex items-center justify-between gap-2 sm:gap-4 sticky top-0 z-20">
      <div className="flex items-center gap-2 sm:gap-4 min-w-0">
        <img src={logo} alt="Game Gems" title="Game Gems" className="h-6 sm:h-12 flex-shrink-0" />
        {/* Inline nav links: desktop only, mobile uses the bottom tab bar instead */}
        <nav className="hidden md:flex items-center gap-1 sm:gap-2 min-w-0">
          <Link to={createUrl('/game-list')} className={navLinkClass('/game-list')}>
            <Gamepad2 className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
            <span>Marketplace</span>
          </Link>
          <Link to={createUrl('/transaction-history')} className={navLinkClass('/transaction-history')}>
            <History className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
            <span>Transactions</span>
          </Link>
        </nav>
      </div>
      <div className="flex items-center px-2.5 sm:px-4 py-1.5 sm:py-2 rounded-full flex-shrink-0 border border-gray-900">
        <img src={diamondicon} alt="Diamond" className="h-4 sm:h-5 mr-2" />
        <span className="text-white font-semibold text-sm sm:text-base">
          <span className="text-green-400">{coinValue !== null ? Number(coinValue).toFixed(2) : '0.00'}</span>
        </span>
      </div>
      {/* <button onClick={handleLogout} className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg shadow-md">Logout</button> */}
    </div>
  );
};

export default Navbar;
